import { Injectable } from "@angular/core";
import { gridItem, preferenceColors, preferenceFontSizes, preferenceTitles } from "src/app/models";

@Injectable({
    providedIn: 'root'
})
export class PreferenceUtilitiesService {
    constructor() { }

    columnSettings(gridItem: gridItem, titlesObj: preferenceTitles): preferenceTitles {
        const preferences = gridItem.setup.preferences;
        let legendTitle = titlesObj.legendTitle;
        let xTitle = titlesObj.xTitle;
        let yTitle = titlesObj.yTitle;
    
        if (preferences) {
            legendTitle = legendTitle ? legendTitle : "";
            xTitle = xTitle ? xTitle : "";
            yTitle = yTitle ? yTitle : "";
            const names = preferences.names;
            for (let i = 0; i < names?.length; i++) {
                names[i].id === 0 ? legendTitle = names[i].name : legendTitle = legendTitle;
                names[i].id === 2 ? xTitle = names[i].name : xTitle = xTitle;
                names[i].id === 4 ? yTitle = names[i].name : yTitle = yTitle;
            }
        }
    
        let result: preferenceTitles = {
            legendTitle,
            xTitle,
            yTitle
        };
    
        return result;
    }

    setFontSizes(gridItem: gridItem): preferenceFontSizes {
        const preferences = gridItem.setup.preferences;	
    
        let result: preferenceFontSizes = {
            legendFontSize: "",
            legendElementsFontSize: "",
            xTitleFontSize: "",
            xLabelsFontSize: "",
            yTitleFontSize: "",
            yLabelsFontSize: ""
        };
    
        if (preferences) {	
            const fonts = preferences.fonts;	
            for (let i = 0; i < fonts?.length; i++) {	
                switch (fonts[i].id) {	
                    case 0: result.legendFontSize = fonts[i].fontSize; break;	
                    case 1: result.legendElementsFontSize = fonts[i].fontSize; break;	
                    case 2: result.xTitleFontSize = fonts[i].fontSize; break;	
                    case 3: result.xLabelsFontSize = fonts[i].fontSize; break;	
                    case 4: result.yTitleFontSize = fonts[i].fontSize; break;	
                    case 5: result.yLabelsFontSize = fonts[i].fontSize; break;	
                }	
            }	
        }
    
        return result;
    }

    setColors(gridItem: gridItem): preferenceColors {
        const preferences = gridItem.setup.preferences;	
        const colorScheme = gridItem.colorScheme;
        let defaultColor = colorScheme === 3 ? "#FFFFFF" : "#30424F";
    
        let result: preferenceColors = {
            legendColor: defaultColor,
            legendElementsColor: defaultColor,
            xTitleColor: defaultColor,
            xLabelsColor: defaultColor,
            yTitleColor: defaultColor,
            yLabelsColor: defaultColor
        };
    
        if (preferences) {	
            const colors = preferences.colors;	
            for (let i = 0; i < colors?.length; i++) {	
                switch (colors[i].id) {	
                    case 0: result.legendColor = colors[i].color; break;	
                    case 1: result.legendElementsColor = colors[i].color; break;	
                    case 2: result.xTitleColor = colors[i].color; break;	
                    case 3: result.xLabelsColor = colors[i].color; break;	
                    case 4: result.yTitleColor = colors[i].color; break;	
                    case 5: result.yLabelsColor = colors[i].color; break;	
                }	
            }	
        }
    
        return result;
    }
}